import { memo, type ReactElement } from 'react';
import type { CarouselEntryType } from 'tsconfig/types';
import { CmsCarousel } from './CmsCarousel';
import { RenderDynamicComponent } from '../CmsContentSection/RenderDynamicComponent/RenderDynamicComponent';

interface ClientCarouselProps {
  contentItem: any;
  slidesContent: any;
  entryTitle: string;
  dataLayerService: any;
  layoutIndex: number;
  aboveFoldCount?: number;
}

/**
 * Client-only Carousel wrapper.
 * Renders the carousel with slide content via RenderDynamicComponent.
 */
const ClientCarousel = memo(
  ({
    contentItem,
    slidesContent,
    entryTitle,
    dataLayerService,
    layoutIndex,
    aboveFoldCount = 0,
  }: ClientCarouselProps): ReactElement => {
    const slides = (slidesContent as CarouselEntryType['fields']['slides'])?.map((content, index) => (
      <CmsCarousel.CmsCarouselSlide
        key={`carousel-${content?.sys?.id}-${index + 1}`}
        dataTestId={`slide-${content?.sys?.id}`}
      >
        <div>
          <RenderDynamicComponent
            contentItem={content}
            dlClickEventHandler={(data: string) =>
              dataLayerService.createCarouselClickEventHandler(contentItem, layoutIndex)(data, index + 1)
            }
            isAboveFold={index < aboveFoldCount}
          />
        </div>
      </CmsCarousel.CmsCarouselSlide>
    ));

    return (
      <CmsCarousel
        slidesPerBlock={contentItem.fields?.slidesPerBlock}
        slidesToScroll={contentItem.fields?.slidesToScroll}
        dataTestId={`carousel-${entryTitle}`}
      >
        {slides}
      </CmsCarousel>
    );
  },
);

export default ClientCarousel;
